Alpine.data('alpine_favorites', () => ({
  isFavoritesLoading: false,

  async addFavorite(sku, callback) {
    this.isFavoritesLoading = true;

    await window.axios.post('/account/favorite/' + sku)
      .then(response => {
        if(typeof clalback === 'function') {
          callback(response);
        }
      })
      .catch(error => {
        window.console.error(error.response, error.response.data);
      })
      .finally(() => this.isFavoritesLoading = false);
  },

  async removeFavorite(sku, callback) {
    this.isFavoritesLoading = true;

    await window.axios.delete('/account/favorite/' + sku)
      .then(response => {
        if(typeof callback === 'function') {
          callback(response);
        }
      })
      .catch(error => {
        // window.console.error(error.response, error.response.data);
        alert('There was a problem deleting this favorite.');
      })
      .finally(() => this.isFavoritesLoading = false);
  },
}));
